import { Flame, Brain, Rocket, Star, Zap, Frown, Sparkles, Target, Trophy, BookOpen, GraduationCap, Award } from 'lucide-react';

interface StreakMessage {
  text: string;
  icon: any; // Lucide icon component
  color: string;
}

export const crimeStreakMessages: { active: StreakMessage[], inactive: StreakMessage[] } = {
  active: [
    { text: "You're on fire! Keep solving!", icon: Flame, color: "text-orange-500" },
    { text: "Unstoppable detective!", icon: Rocket, color: "text-red-500" },
    { text: "The city needs you!", icon: Siren, color: "text-blue-500" }, // Siren isn't imported, let's stick to standard
    { text: "Master Investigator!", icon: Star, color: "text-yellow-500" },
  ],
  inactive: [
    { text: "Start your streak today!", icon: Target, color: "text-green-500" },
    { text: "Solve a crime now!", icon: Search, color: "text-indigo-500" }, // Search needs import
    { text: "Become a detective!", icon: Sparkles, color: "text-purple-500" },
  ]
};

export const trainingStreakMessages: { active: StreakMessage[], inactive: StreakMessage[] } = {
  active: [
    { text: "Brain power surging!", icon: Brain, color: "text-purple-500" },
    { text: "Memory master!", icon: Zap, color: "text-yellow-500" },
    { text: "Keep learning!", icon: Rocket, color: "text-pink-500" },
    { text: "You're getting smarter!", icon: Sparkles, color: "text-indigo-500" },
  ],
  inactive: [
    { text: "Train your brain!", icon: Dumbbell, color: "text-emerald-500" }, // Dumbbell needs import
    { text: "Start learning today!", icon: Target, color: "text-blue-500" },
    { text: "Boost your memory!", icon: Brain, color: "text-purple-500" },
  ]
};

export const wordDayStreakMessages: { active: StreakMessage[], inactive: StreakMessage[] } = {
  active: [
    { text: "Vocabulary Master!", icon: CalendarHeart, color: "text-red-500" },
    { text: "Word Wizard!", icon: Sparkles, color: "text-purple-500" },
    { text: "Language Legend!", icon: Star, color: "text-yellow-500" },
    { text: "Consistency is key!", icon: Target, color: "text-green-500" },
  ],
  inactive: [
    { text: "Learn a new word!", icon: CalendarHeart, color: "text-pink-500" },
    { text: "Start your journey!", icon: Rocket, color: "text-orange-500" },
    { text: "Expand your mind!", icon: Brain, color: "text-indigo-500" },
  ]
};

// Re-import missing icons to fix the object definition above
import { Siren, Search, Dumbbell, CalendarHeart } from 'lucide-react';

export const wordsLearnedMessages: { active: StreakMessage[], inactive: StreakMessage[] } = {
  active: [
    { text: "Amazing progress! Keep it up!", icon: Trophy, color: "text-indigo-500" },
    { text: "You're building an impressive vocabulary!", icon: BookOpen, color: "text-blue-500" },
    { text: "Every word counts! Great job!", icon: Star, color: "text-yellow-500" },
    { text: "Your knowledge is growing!", icon: GraduationCap, color: "text-purple-500" },
    { text: "Vocabulary champion!", icon: Award, color: "text-green-500" },
    { text: "Learning never stops!", icon: Rocket, color: "text-pink-500" },
    { text: "You're mastering new words!", icon: Sparkles, color: "text-indigo-500" },
  ],
  inactive: [
    { text: "Start learning your first word!", icon: Target, color: "text-indigo-500" },
    { text: "Begin your vocabulary journey!", icon: Rocket, color: "text-blue-500" },
    { text: "Learn your first word today!", icon: BookOpen, color: "text-purple-500" },
    { text: "Ready to expand your vocabulary?", icon: Brain, color: "text-indigo-500" },
  ]
};
